import React from "react";
import Anav from "../components/Anav";
import Dtable from "../components/Dtable";
import Homefooter from "../components/Homefooter";

function Drivers() {
    return (
        <>
            <Anav />
            <Dtable />
            <Homefooter />
        </>
    );
}

export default Drivers;